import script from "./DeleteConfirmationModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeleteConfirmationModal.vue?vue&type=script&setup=true&lang=ts"

import "./DeleteConfirmationModal.vue?vue&type=style&index=0&id=096beebd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-096beebd"]])

export default __exports__